import { DailyJobSchema, EmergencyServicesJobSchema, OtrJobSchema, } from '@eigtech/restoration-types';
import { getResourceId } from '@eigtech/shared-corn';
import { destructureJobId, jobAbbreviationFromJobType } from './ids.js';
export const getValidJob = (job, jobType) => {
    const jobSchemaMap = {
        daily: DailyJobSchema,
        emergencyServices: EmergencyServicesJobSchema,
        otr: OtrJobSchema,
    };
    const parsed = jobSchemaMap[jobType].safeParse(job);
    if (parsed.success) {
        return parsed.data;
    }
};
export const ensureValidJob = (job, jobType) => {
    const validJob = getValidJob(job, jobType);
    if (!validJob) {
        throw new Error(`invalid ${jobType} job`);
    }
    return validJob;
};
export function getJobLabelFromId(jobId) {
    const { jobFactor, jobType, stateAbbreviation, year } = destructureJobId(jobId);
    return [year, jobFactor, jobAbbreviationFromJobType(jobType), stateAbbreviation]
        .filter((part) => !!part)
        .join('-');
}
export function getJobLabelFromCorn(jobCorn) {
    const jobId = getResourceId(jobCorn);
    return getJobLabelFromId(jobId);
}
